<!-- views/Login.vue -->
<template>
    <div class="login-page">
      <div class="login-container">
        <h2 class="login-title">欢迎登录</h2>
        <form @submit.prevent="handleLogin" class="login-form">
          <div class="form-group">
            <label for="username">用户名</label>
            <input
              type="text"
              id="username"
              v-model="username"
              placeholder="请输入用户名"
              required
            />
          </div>
          <div class="form-group">
            <label for="password">密码</label>
            <input
              type="password"
              id="password"
              v-model="password"
              placeholder="请输入密码"
              required
            />
          </div>
          <button type="submit" class="login-btn">登录</button>
        </form>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import api from '../api/api'; // 导入封装的 API
  
  export default {
    name: 'Login',
    data() {
      return {
        username: '',
        password: '',
        errorMessage: ''
      };
    },
    methods: {
      async handleLogin() {
        try {
          const response = await api.post('/user/login', {
            username: this.username,
            password: this.password
          });
  
          // 登录成功，存储 token
          localStorage.setItem('token', response.data.token);
          // 重定向到产品管理页面
          this.$router.push('/product-management');
        } catch (error) {
          console.error('登录错误:', error);
          this.errorMessage = '登录失败，请检查网络或用户名/密码！';
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
  }
  
  .login-container {
    background: #ffffff;
    border-radius: 12px;
    padding: 40px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    width: 100%;
    max-width: 400px;
    text-align: center;
  }
  
  .login-title {
    margin: 0 0 30px;
    color: #333;
    font-size: 24px;
    font-weight: 600;
  }
  
  .login-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  
  .form-group label {
    font-size: 14px;
    color: #555;
    margin-bottom: 8px;
  }
  
  .form-group input {
    padding: 10px;
    font-size: 16px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    outline: none;
    transition: border-color 0.3s ease;
  }
  
  .form-group input:focus {
    border-color: #5a9bd4;
  }
  
  .login-btn {
    background: #00c4b4;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s ease;
  }
  
  .login-btn:hover {
    background: #00b3a4;
  }
  
  .error-message {
    margin-top: 20px;
    color: #e57373;
    font-size: 14px;
  }
  </style>